// serverAdapter.js — turns the component's queryState into a request and normalizes
// the app's {st, payload, total_pages} envelope into { ok, rows, totalPages, message }.
export function makeServerAdapter({ endpoint, buildFormData }) {
   return {
      endpoint,
      buildFormData,
      parseResponse(responseData) {
         if (!responseData || responseData.st !== 1 || !Array.isArray(responseData.payload)) {
            return {
               ok: false,
               rows: [],
               totalPages: 0,
               totalRows: null,
               stateCounts: null,
               message: responseData?.m_en || responseData?.mg || "Failed to load",
            };
         }
         return {
            ok: true,
            rows: responseData.payload,
            totalPages: responseData.total_pages || 0,
            totalRows: responseData.total_rows ?? null,
            stateCounts: responseData.state_counts ?? null,
            message: "",
         };
      },
   };
}
